import React from 'react';
import css from './css.less';

import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import EditableTable, {
  EditIcon,
} from '@/src/components/EditableTable/EditableTable';
//import _ from 'lodash';
import {
  TableSelect,
  TableNumberInput,
  //TableSearchSelect,
} from 'src/components/EditableTable/TableForm/TableForm';
import {
  TableInput,

  //TableSearchSelect,
} from 'src/components/EditableTable/TableForm1';
//import { addSupplier } from 'src/request/common/hsCode';
import { EnumMode } from 'src/components/Antd/NumberInput/type';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { useSelector } from 'react-redux';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';

const CustomInformation = (props) => {
  const basicSetting = useSelector(getBasicSetting());
  const currency = get(basicSetting, 'currencyCode');
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    items,
    customInformationItemsOnChange,
    customInformationItemsOnAdd,
    countries: oriCountries = [],
    disabled,
  } = props;
  const itemsOnChange = (index, settings) => {
    if (customInformationItemsOnChange)
      customInformationItemsOnChange(false, index, settings);
  };
  const itemsOnDelete = (index) => {
    if (customInformationItemsOnChange)
      customInformationItemsOnChange(true, index);
  };
  const countries = React.useMemo(() => {
    return oriCountries.map((i) => {
      return {
        label: i.name,
        value: i.code,
      };
    });
  }, [oriCountries]);

  const columns = React.useMemo(() => {
    return [
      {
        title: () => (
          <div className={css.firstHeader}>
            <EditIcon />
            <span>{getI18n('general.title')}</span>
          </div>
        ),
        key: 'title',
        childGenerate: (text, record, index) => {
          const { title, titleError } = record;
          return (
            <TableInput
              disabled={disabled}
              maxLength={50}
              error={titleError}
              value={title}
              label={title}
              onChange={(e) => {
                itemsOnChange(index, { title: e });
              }}
            />
          );
        },
        minWidth: 300,
        default: true,
      },
      {
        title: () => (
          <div>
            <EditIcon />
            <span>{getI18n('general.quantity')}</span>
          </div>
        ),

        childGenerate: (text, record, index) => {
          const { quantity, quantityError } = record;
          return (
            <TableNumberInput
              disabled={disabled}
              min={0}
              error={quantityError}
              value={quantity}
              onChange={(e) => {
                itemsOnChange(index, { quantity: e });
              }}
            />
          );
        },
        key: 'quantity',
        minWidth: 112,
        default: true,
      },
      {
        title: () => (
          <div>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.productSetSelection_Unit_price',
              )}
              {currency ? `(${currency})` : ``}
            </span>
          </div>
        ),

        childGenerate: (text, record, index) => {
          const { unitPrice, unitPriceError } = record;
          return (
            <TableNumberInput
              disabled={disabled}
              error={unitPriceError}
              mode={EnumMode.money}
              value={unitPrice}
              onChange={(e) => {
                itemsOnChange(index, { unitPrice: e });
              }}
            />
          );
        },
        key: 'unitPrice',
        minWidth: 144,
        default: true,
      },
      {
        title: () => (
          <div>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.customInformation_component_Country/Region',
              )}
            </span>
          </div>
        ),

        childGenerate: (text, record, index) => {
          const { regionOfOrigin, regionOfOriginError } = record;

          return (
            <TableSelect
              disabled={disabled}
              getPopupContainer={() =>
                document.getElementById('CustomInformationTable')
              }
              error={regionOfOriginError}
              value={regionOfOrigin}
              onChange={(e) => {
                itemsOnChange(index, { regionOfOrigin: e });
              }}
              optionsList={countries}
              label={
                (countries.find((i) => i.value === regionOfOrigin) || {})
                  .label || '-'
              }
            />
          );
        },
        key: 'regionOfOrigin',
        minWidth: 212,
        default: true,
      },
      {
        title: () => (
          <div>
            <EditIcon />
            <span>
              {getI18n(
                'allProducts.addproductset.customInformation_component_HSCode',
              )}
            </span>
          </div>
        ),

        childGenerate: (text, record, index) => {
          const { hsCodeError, hsCode } = record;

          return (
            <TableInput
              disabled={disabled}
              error={hsCodeError}
              value={get(hsCode, 'code')}
              label={get(hsCode, 'code')}
              itemProps={{
                maxLength: 12,
                fullyControlledFilter: (str) => {
                  if (str) {
                    return str.replace(
                      /[^0-9]/g,
                      //`~!#$%^&*()+=<>?:"{}|,\/;\\[\]·~！#￥%……&*（）——+={}|《》？：“”【】、；‘’，。、
                      '',
                    );
                  } else {
                    return str;
                  }
                },
              }}
              onChange={(e) => {
                itemsOnChange(index, {
                  hsCode: {
                    uuid: null,
                    description: null,
                    code: e,
                  },
                });
              }}
            />
            // <TableSearchSelect
            //   disabled={disabled}
            //   placeholder={'Type to search'}
            //   notFoundContent={<div>Not Found</div>}
            //   value={(hsCode || {}).uuid}
            //   onChange={(e, op) => {
            // itemsOnChange(index, {
            //   hsCode: {
            //     uuid: op.value,
            //     description: op['data-description'],
            //     code: op['data-code'],
            //   },
            // });
            //   }}
            //   label={`${(hsCode || {}).code || ''} ${
            //     (hsCode || {}).description || ''
            //   }`}
            //   onSearch={_.debounce(searchHsCode, 500)}
            //   optionsList={hsCodesOptions}
            //   error={hsCodeError}
            // />
          );
        },
        key: 'hsCode',
        minWidth: 410,
        default: true,
      },
    ];
  }, [oriCountries, items]);

  return (
    <SectionWrapper
      id='ProductCustomInformationSetting'
      title={getI18n(
        'allProducts.addproductset.customInformation_component_Custominformation',
      )}
      subtitle={getI18n(
        'allProducts.addproductset.customInformation_component_Custominformation_subtitle',
      )}>
      <Row
        elements={[
          {
            child: (
              <EditableTable
                disableAdd={disabled}
                disabled={disabled}
                addFun={customInformationItemsOnAdd}
                data={items}
                columns={columns}
                id='CustomInformationTable'
                rowDeleteFunc={itemsOnDelete}
              />
            ),
          },
        ]}
      />
    </SectionWrapper>
  );
};
export default CustomInformation;
